(function() {
angular.module('ocorrencias')
  .component('ocorrenciasListItem', {
    templateUrl: 'js/custom-components/ocorrencias-list/ocorrencias-list-item.component.html',
    bindings: {
      ocorrenciaItem: "=",
      onListOpenOcorrenciaDetail: "&"
    },
    controller: 'OcorrenciasListItemController',
    controllerAs: 'ctrl'
  })

  .filter('truncate', function () {
    return function (text, length) {
      if (!text) return '';
      length = length || 60;

      if (text.length <= length) return text;
      const truncatedText = text.substring(0, length);
      const lastSpaceIndex = truncatedText.lastIndexOf(' ');
  
      if (lastSpaceIndex > -1) {
        return truncatedText.substring(0, lastSpaceIndex) + '...';
      }
      return text;
    };
  });

})();